// Since when does the Live wall count as "new" for this person?
//
// The More badge counts public activity newer than the last time they opened Live. With
// nothing stored (first boot on this device) the fallback was "the last 7 days", which
// handed a brand-new account a 9+ badge on its first screen, pointing at strangers'
// marks it had never seen (member walk, 2026-10-19). A new account's baseline is its
// own creation; an older account on a fresh device keeps the week.
export function liveSince(stored, createdAt, now = Date.now()) {
  if (stored) return stored
  const weekAgo = now - 7 * 86400000
  const created = createdAt ? Date.parse(createdAt) : NaN
  return new Date(Number.isFinite(created) && created > weekAgo ? created : weekAgo).toISOString()
}
